/**
 * A same-origin panel path — `/x`, never the protocol-relative `//host`.
 *
 * Notification links, guidance deep links and tip CTAs are data from the
 * server; this is the one check before any of them is handed to `navigate()`.
 */
export function isPanelPath(link: string | null | undefined): link is string {
  return Boolean(link && link.startsWith('/') && !link.startsWith('//'));
}
